import React from "react";
import styles from "./SideBanner.module.css";

type SideBannerProps = {
  side: "left" | "right";
};

const SideBanner: React.FC<SideBannerProps> = ({ side }) => {
  return (
    <aside
      className={`${styles.sideBanner} ${
        side === "left"
          ? styles["sideBanner--left"]
          : styles["sideBanner--right"]
      }`}
    />
  );
};

export default SideBanner;
